import {useMutation} from "@apollo/client";
import toast from "react-hot-toast";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {DeleteIncidentResponse, GQL_DELETE_INCIDENT, GQL_INCIDENTS} from "@/lib/queries/statuspages.ts";

export interface IncidentDeleteProps {
  statusPageID: number;
  incidentID: number;
  incidentName: string;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const IncidentDelete = ({statusPageID, incidentID, incidentName, show, setShow}: IncidentDeleteProps) => {
  const [deleteIncident, {reset, loading}] = useMutation<DeleteIncidentResponse>(GQL_DELETE_INCIDENT, {
    refetchQueries: [GQL_INCIDENTS],
  });

  const handleSubmit = async () => {
    const response = await deleteIncident({
      variables: {statusPageID, incidentID},
    });
    if (response.data?.deleteIncident?.success) {
      setShow(false);
    } else {
      toast.error("Failed to delete incident.");
    }
  };

  return (
    <DeleteActionDialog
      show={show}
      loading={loading}
      title={"Delete Incident"}
      onConfirm={handleSubmit}
      onCancel={() => {
        setShow(false);
        reset();
      }}
    >
      Are you sure you want to permanently delete the incident{" "}
      <span className={"pulseTextBodyBold"}>{incidentName}</span>?
    </DeleteActionDialog>
  );
};
